(function employeeFileFindControllerDefinition() {
    'use strict';

    angular.module('EmployeeFile')
        .controller('EmployeeFileFindController', [
            '$q', '$scope', '$state', '$translate', 'errorsExtend', '$filter', 'documentContainerService', 'processService', 'containerTypeService', 'storageService', 'fileDownloader', 'authExtend', 'messages', 'configViewService', 'adminContainerTypeService', '$window', 'certificateService', 'profileCertificateService',
            function employeeFileController($q, $scope, $state, $translate, errors, $filter, documentContainerService, processService, containerTypeService, storageService, fileDownloader, authExtend, messages, configViewService, adminContainerTypeService, $window, certificateService, profileCertificateService) {

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.loadCertificateProviders = function () {
                    certificateService.getProviders(0, authExtend.getOrganizationId()).then(function (result) {
                        $scope.certificateProviders = result;
                    });
                };

                $scope.load = function () {

                    $scope.accordionState = {
                        isOpen: true
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0,
                        success: 0,
                        total: 0
                    };

                    $scope.items = [];
                    $scope.showResult = false;
                    $scope.emptyOu = true;
                    $scope.checkAll = false;
                    $scope.loading = false;
                    $scope.filter = ['_nroleg', '_nom', '_ape', '_cuil'];
                    $scope.apellidoSystemName = '_ape';
                    $scope.nombreSystemName = '_nom';
                    $scope.cuilSystemName = '_cuil';
                    $scope.userIdSystemName = '_userId';
                    $scope.systemNames = {};
                    $scope.find = storageService.getEmployeeFilesFilter();
                    $scope.certificateStartPermission = authExtend.isInRole('CERTIFICATE START');
                    $scope.sendDocumentPermission = authExtend.isInRole('DOCUMENT WRITE');

                    $scope.loadContainerType();
                    $scope.loadCertificateProviders();

                    configViewService.getById('CPPCertificateRRHH').then(function (result) {
                        if (result && result.processTypes.length > 0) {
                            $scope.certificateProcessType = result.processTypes[0];
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.loadContainerType = function () {
                    adminContainerTypeService.getMetadataMappings(authExtend.getOrganizationRoot()).then(function (result) {
                        var customContainerType = undefined;

                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                customContainerType = result[i];
                            }
                        }

                        if (customContainerType) {
                            // Valido que tenga permisos para el tc
                            containerTypeService.isContainertypeInRole(['EMPLOYEEFILE READ', 'EMPLOYEEFILE WRITE', 'EMPLOYEEFILE ADM'], customContainerType.id).then(function (r) {
                                if (!r) {
                                    errors.showError('EDRTC');
                                    $scope.cancel();
                                }
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });

                            customContainerType.targetMetadataMapping.forEach(function (item, index) {
                                if (item.metadataSystemName === $scope.apellidoSystemName) {
                                    $scope.apellidoSystemName = customContainerType.sourceMetadataMapping[index].metadataSystemName;
                                }

                                if (item.metadataSystemName === $scope.nombreSystemName) {
                                    $scope.nombreSystemName = customContainerType.sourceMetadataMapping[index].metadataSystemName;
                                }

                                if (item.metadataSystemName === $scope.cuilSystemName) {
                                    $scope.cuilSystemName = customContainerType.sourceMetadataMapping[index].metadataSystemName;
                                }

                                if (item.metadataSystemName === $scope.userIdSystemName) {
                                    $scope.userIdSystemName = customContainerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                            });

                            if ($scope.find.employeeFileTypes.length <= 0) {
                                $scope.loadMetadata(customContainerType);
                            }

                            $scope.loadSystemNames(customContainerType, true);
                            $scope.findEmployeeFiles();
                        } else {
                            containerTypeService.getBySystemName("_leg").then(function (result) {
                                if ($scope.find.employeeFileTypes.length <= 0) {
                                    $scope.loadMetadata(result);
                                }

                                $scope.loadSystemNames(result, false);
                                $scope.findEmployeeFiles();
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (doc) {
                            doc.check = $scope.checkAll;
                        });
                    }
                };

                $scope.loadMetadata = function (containerType) {
                    var type = {
                        SystemName: containerType.systemName,
                        employeeFileTypeName: containerType.name,
                        employeeFileTypeId: containerType.id,
                        metadatas: []
                    };

                    containerType.metadata.forEach(function (metadata) {
                        if (metadata.isSearchCriteria) {
                            type.metadatas.push({
                                idObject: type.employeeFileTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                maskOptions: metadata.metadataMaskOption,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                metadataSearchTypeTo: undefined, // cada control pisa el valor
                                metadataType: metadata.metadataType,
                                metadataSystemName: metadata.metadataSystemName,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                mask: metadata.metadataMask,
                                maskPlaceHolder: metadata.metadataMaskPlaceHolder
                            });
                        }
                    });

                    $scope.find.employeeFileTypes.push(type);
                };

                $scope.loadSystemNames = function (containerType, isCustomContainerType) {
                    if (isCustomContainerType) {
                        containerType.targetMetadataMapping.forEach(function (item, index) {
                            if ($scope.filter.indexOf(item.metadataSystemName) >= 0) {
                                $scope.systemNames[item.metadataSystemName] = {
                                    sn: containerType.sourceMetadataMapping[index].metadataSystemName,
                                    label: containerType.sourceMetadataMapping[index].metadataLabel,
                                    visible: containerType.sourceMetadataMapping[index].isResultCriteria
                                };
                            }
                        });
                    } else {
                        containerType.metadata.forEach(function (metadata) {
                            if ($scope.filter.indexOf(metadata.metadataSystemName) >= 0) {
                                $scope.systemNames[metadata.metadataSystemName] = {
                                    sn: metadata.metadataSystemName,
                                    label: metadata.metadataLabel,
                                    visible: metadata.isResultCriteria
                                };
                            }
                        });
                    }
                };

                $scope.clean = function () {
                    storageService.clearEmployeeFilesFilter();
                    $scope.find = storageService.getEmployeeFilesFilter();
                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                    $scope.loadContainerType();
                };

                $scope.actionFind = function () {
                    storageService.setEmployeeFilesFilter($scope.find);
                    $scope.items = [];
                    $scope.employeeFileTypes = [];
                    $scope.showResult = false;

                    if (!$scope.searchDocuments.$valid || $scope.find.employeeFileTypes.length <= 0) {
                        $scope.searchDocuments.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    return $scope.findEmployeeFiles();
                };

                $scope.findEmployeeFiles = function (allItems) {
                    var filters = {
                        Complete: true,
                        ContainerTypes: []
                    };

                    if ($scope.find.organizationalUnit) {
                        filters.OrganizationUnitIds = [$scope.find.organizationalUnit.id];
                    }

                    $scope.find.employeeFileTypes.forEach(function (type) {
                        type.Page = 1;
                        type.ItemPerPage = !allItems ? $scope.data.itemsPerPage : 0;
                        type.DocumentTypeId = type.employeeFileTypeId;
                        type.OrderBy = [
                            "m." + $scope.apellidoSystemName + "_l",
                            "m." + $scope.nombreSystemName + "_l"
                        ];
                        filters.ContainerTypes.push(type);
                    });

                    if (!allItems) {
                        $scope.showResult = true;
                        $scope.showPanel();
                        storageService.setEmployeeFilesFilter($scope.find);
                    }

                    return documentContainerService.advancedGet(filters).then(function (result) {
                        if (allItems) {
                            return result.values;
                        }

                        $scope.items = result.values;

                        if ($scope.items.length > 0) {
                            $scope.accordionState.isOpen = false;
                        }
                        $scope.employeeFileTypes = result.documentTypes;
                        if ($scope.employeeFileTypes.length > 0) {
                            $scope.employeeFileTypes[0].selected = true;
                            $scope.currentSelectedTypeIsShareable = $scope.employeeFileTypes[0].isShareable;
                        }

                        $scope.headers = result.headers;
                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;
                        $scope.data.currentPage = 1;

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.add = function () {
                    $state.go('employee-file-add');
                };

                $scope.edit = function (docu) {
                    $state.go('employee-file-edit', { id: docu.id });
                };

                $scope.view = function (employeeFile) {
                    storageService.setStateBackFind('employee-file-find');
                    $state.go('employee-file-detail', { id: employeeFile.id });
                };

                $scope.exportToExcel = function () {
                    return $translate(['DocumentOrganizationalUnits'])
                        .then(function (translated) {
                            var filters = {
                                Complete: true,
                                ContainerTypes: []
                            };

                            $scope.find.employeeFileTypes.forEach(function (type) {
                                type.Page = 1;
                                type.ItemPerPage = 0;
                                type.DocumentTypeId = type.employeeFileTypeId;
                                type.OrderBy = [
                                    "m." + $scope.apellidoSystemName,
                                    "m." + $scope.nombreSystemName
                                ];

                                filters.ContainerTypes.push(type);
                            });

                            var aditionalData = [];

                            aditionalData.push({ key: 'OrganizationalUnitId', value: 'Unidad Organizacional' });

                            return documentContainerService.exportToXLS(filters, $scope.headers, "Legajos", aditionalData).then(function (result) {
                                var d = new Date();

                                var docName = "Legajos";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 403) {
                                    errors.showError('FileForbidden');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                };

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };

                $scope.pageFind = function () {
                    $scope.items = [];

                    var find = storageService.getEmployeeFilesFilter();

                    if (find.employeeFileTypes.length <= 0) {
                        $scope.data.totalItems = 0;
                        errors.showError('VerifyFormData');
                        return;
                    }

                    var filters = {
                        PartialQuery: true,
                        ContainerTypes: []
                    };

                    if ($scope.find.organizationalUnit) {
                        filters.OrganizationUnitIds = [$scope.find.organizationalUnit.id];
                    }

                    find.employeeFileTypes.forEach(function (type) {
                        type.Page = $scope.data.currentPage,
                            type.ItemPerPage = $scope.data.itemsPerPage;
                        type.DocumentTypeId = type.employeeFileTypeId;
                        filters.ContainerTypes.push(type);
                    });

                    return documentContainerService.advancedGet(filters).then(function getOk(result) {
                        $scope.items = result.values;

                        if ($scope.items.length > 0) {
                            $scope.accordionState.isOpen = false;
                        }

                        $scope.headers = result.headers;
                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load();

                $scope.certificateRequest = function (provider) {
                    $scope.selectedProvider = provider || $scope.certificateProviders[0];

                    var employeeFiles = $filter('filter')($scope.items, function (item) {
                        return item.check;
                    });

                    if (employeeFiles.length === 0) {
                        errors.showWarning('EmployeeFileSelectItemWarning');
                        return false;
                    }

                    return messages.showConfirm($scope.selectedProvider.id === 1 ? 'RequestMultipleCertificatesConfirm' : 'RequestMultipleCertificatesConfirmByProvider').then(function (result) {
                        if (result) {
                            $scope.loading = true;
                            $scope.data.success = 0;
                            $scope.data.total = employeeFiles.length;
                            $scope.data.legajos = '';

                            var promise = $q.all([]);

                            angular.forEach(employeeFiles, function (item) {

                                promise = promise.finally(function () {
                                    return getDocumentContainer(item)
                                        .then(createCertificate);
                                });
                            });

                            promise.finally(function () {
                                $scope.loading = false;
                                if ($scope.data.legajos) {
                                    $scope.data.legajos = $scope.data.legajos.slice(0, -2);
                                }

                                errors.showSuccess('EmployeeFileCertificateSolicitudeResult', 'InfoTitle', { data: $scope.data });
                            });
                        }
                    });
                };

                $scope.certificateRequestAll = function (provider) {
                    $scope.selectedProvider = provider || $scope.certificateProviders[0];
                    return messages.showConfirm($scope.selectedProvider.id === 1 ? 'RequestMultipleCertificatesConfirm' : 'RequestMultipleCertificatesConfirmAllByProvider').then(function (result) {
                        if (result) {
                            $scope.loading = true;

                            var filters = {
                                Complete: true,
                                ContainerTypes: []
                            };

                            if ($scope.find.organizationalUnit) {
                                filters.OrganizationUnitIds = [$scope.find.organizationalUnit.id];
                            }

                            $scope.find.employeeFileTypes.forEach(function (type) {
                                type.Page = 1,
                                    type.ItemPerPage = 0;
                                type.DocumentTypeId = type.employeeFileTypeId;
                                filters.ContainerTypes.push(type);
                            });

                            return documentContainerService.advancedGet(filters).then(function (result) {
                                var items = result.values;

                                $scope.data.success = 0;
                                $scope.data.total = items.length;
                                $scope.data.legajos = '';

                                var promise = $q.all([]);

                                angular.forEach(items, function (item) {
                                    promise = promise.finally(function () {
                                        return getDocumentContainer(item)
                                            .then(createCertificate);
                                    });
                                });

                                promise.finally(function () {
                                    $scope.loading = false;
                                    if ($scope.data.legajos) {
                                        $scope.data.legajos = $scope.data.legajos.slice(0, -2);
                                    }

                                    errors.showSuccess('EmployeeFileCertificateSolicitudeResult', 'InfoTitle', { data: $scope.data });
                                });
                            }, function getError(error) {
                                errors.showError(error);
                            });
                        }
                    });
                };

                $scope.getSelectedItems = function (items, all) {
                    var selectedItems = {
                        headers: [],
                        items: []
                    };

                    for (var i = 0; i < items.length; i++) {
                        if (!items[i].check && !all) {
                            continue;
                        }

                        selectedItems.items.push({
                            id: items[i].id,
                            organizationalUnitName: items[i].organizationalUnitName,
                            organizationalUnitId: items[i].organizationalUnitId,
                            check: false,
                            metadata: []
                        });

                        var indices = [];

                        for (var j = 0; j < $scope.filter.length; j++) {
                            var idx = $scope.headers.indexOf($scope.systemNames[$scope.filter[j]].label);
                            if (idx >= 0 && idx < items[i].metadata.length) {
                                $scope.systemNames[$scope.filter[j]].idx = idx;
                                indices.push(idx);
                            }
                        }

                        indices.sort(function (a, b) { return a - b; });

                        for (var h = 0; h < indices.length; h++) {
                            selectedItems.items[selectedItems.items.length - 1].metadata.push(items[i].metadata[indices[h]]);
                        }
                    }

                    for (var k in $scope.systemNames) {
                        if ($scope.systemNames[k].visible) {
                            selectedItems.headers.push({
                                idx: $scope.systemNames[k].idx || 0,
                                systemName: $scope.systemNames[k].sn,
                                label: $scope.systemNames[k].label
                            });
                        }
                    }

                    selectedItems.headers.sort(function (a, b) { return a.idx - b.idx; });

                    return selectedItems;
                };

                $scope.sendDocument = function () {
                    var employeeFiles = $scope.getSelectedItems($scope.items, false);

                    if (employeeFiles.length === 0) {
                        errors.showWarning('EmployeeFileSelectItemWarning');
                        return false;
                    }

                    return $state.go('document-rrhh-add', { employeeFiles: employeeFiles.items, headers: employeeFiles.headers });
                };

                $scope.sendDocumentAll = function () {
                    $scope.findEmployeeFiles(true).then(function (result) {
                        var employeeFiles = $scope.getSelectedItems(result, true);

                        return $state.go('document-rrhh-add', { employeeFiles: employeeFiles.items, headers: employeeFiles.headers });
                    });
                };

                var getDocumentContainer = function (employeeFile) {
                    return documentContainerService.getTreeOf(employeeFile.id).then(function (result) {
                        return result[0];
                    }, function (error) {
                        $scope.data.legajos += employeeFile.metadata[0] + ', ';
                    });
                }, createCertificate = function (employeeFile) {
                    if (employeeFile) {
                        switch ($scope.selectedProvider.id) {
                            case 1: //encode
                                var params = {
                                    processTypeId: $scope.certificateProcessType.processTypeId,
                                    processTypeName: $scope.certificateProcessType.name,
                                    organizationalUnitId: employeeFile.organizationalUnitId,
                                    legajoId: employeeFile.id
                                };

                                return processService.createCertificate(params).then(function () {
                                    $scope.data.success++;
                                    return employeeFile;
                                }, function () {
                                    $scope.data.legajos += employeeFile.metadata[0] + ', ';
                                });
                            case 2: //nacion
                            case 3: //lakaut
                                return $scope.checkExistingCertificate(employeeFile).then($scope.saveCertificate);
                            default:
                        }
                    }

                    return false;
                };

                $scope.saveCertificate = function (employeeFile) {
                    if (employeeFile) {
                        var userIdMetadata = $filter('filter')(employeeFile.metadatas, { metadataSystemName: $scope.userIdSystemName }, true);
                        var cuilMetadata = $filter('filter')(employeeFile.metadatas, { metadataSystemName: $scope.cuilSystemName }, true);

                        var certificateAux = {
                            userId: userIdMetadata.length > 0 ? userIdMetadata[0].metadataValue : undefined,
                            type: 0, //empleado
                            providerId: $scope.selectedProvider.id,
                            revocationPin: '',
                            cuil: cuilMetadata.length > 0 ? cuilMetadata[0].metadataValue : undefined
                        };

                        return profileCertificateService.upload(certificateAux).then(function () {
                            $scope.data.success++;
                            return employeeFile;
                        });
                    }

                    return false;
                };

                $scope.checkExistingCertificate = function (employeeFile) {
                    var userIdMetadata = $filter('filter')(employeeFile.metadatas, { metadataSystemName: $scope.userIdSystemName }, true);
                    var cuilMetadata = $filter('filter')(employeeFile.metadatas, { metadataSystemName: $scope.cuilSystemName }, true);

                    var filters = {
                        userId: userIdMetadata.length > 0 ? userIdMetadata[0].metadataValue : undefined,
                        certificateTypeId: 0, //empleado
                        certificateProviderId: $scope.selectedProvider.id,
                        cuil: cuilMetadata.length > 0 ? cuilMetadata[0].metadataValue : undefined
                    };

                    return certificateService.get(filters).then(function (result) {
                        return false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.nocert) {
                            return employeeFile;
                        }

                        return false;
                    });
                };
            }
        ]);
})();